//import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import {createBootstrap} from 'bootstrap-vue-next'
import App from './App.vue'
import router from './router'
import tooltip from "./directives/tooltip.js";
import "@/assets/tooltip.css";

import VueExcelEditor from 'vue3-excel-editor'
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
//import { useDbCache } from './composables/useDbCache'

//export const cacheService = useDbCache()
const pinia = createPinia()
const vbs = createBootstrap({components: true, directives: true})
const app = createApp(App)
/*
window.popStateDetected = false
window.addEventListener('popstate', () => {
  window.popStateDetected = true
})
*/
//app.directive("tooltip", tooltip);
app.directive("tooltip", tooltip);
app.use(vbs)
app.use(pinia)
app.use(router)
app.use(VueExcelEditor)
//app.use(cacheService)
//app.use(createBootstrap()) 
app.mount('#app')

//see https://bootstrap-vue-next.github.io/bootstrap-vue-next/docs.html
